import { useAuth } from '../../hooks/useAuth';
import { FACTURES_VIEW_ROLES } from '../../constants/roles';
import * as S from './NavigationMenu.styles';

const NavigationMenu = ({
	className,
	onClose,
}: {
	className?: string;
	onClose: () => void;
}) => {
	const { user } = useAuth();
	const facturesVisible = (() => {
		const roles = (user?.roles as readonly string[]) ?? [];
		return FACTURES_VIEW_ROLES.some((r) => roles.includes(r));
	})();
	return (
		<div className={className}>
			<S.MenuContainer>
				<S.StyledUL>
					<li>
						<S.StyledLink to="/" onClick={onClose}>
							Inici
						</S.StyledLink>
					</li>
					{/* <li>
						<S.StyledLink to="/unitats" onClick={onClose}>Unitats</S.StyledLink>
					</li>
					<li>
						<S.StyledLink to="/caps" onClick={onClose}>Caps</S.StyledLink>
					</li> */}
					<li>
						<S.StyledLink to="/galeria" onClick={onClose}>
							Galeria
						</S.StyledLink>
					</li>
					<li>
						<S.StyledLink to="/posts" onClick={onClose}>
							Què fem?
						</S.StyledLink>
					</li>
					{facturesVisible && (
						<li>
							<S.StyledLink to="/factures" onClick={onClose}>
								Factures
							</S.StyledLink>
						</li>
					)}
					<li>
						<S.StyledLink to="/calendari" onClick={onClose}>
							Calendari
						</S.StyledLink>
					</li>
					<li>
						<S.StyledLink to="/contacte" onClick={onClose}>
							Contacte
						</S.StyledLink>
					</li>
					<li>
						<S.StyledLink to="/rocacorba" onClick={onClose}>
							Rocacorba
						</S.StyledLink>
					</li>
				</S.StyledUL>
			</S.MenuContainer>
		</div>
	);
};

export default NavigationMenu;
